// degen-kong — entry. Boots the Phaser game with the full scene array
// (Wave 1 only the first three actually run; Run/RunUI/Cashier are
// registered now so Waves 2–5 can land without main.ts edits).
//
// Native render resolution 320 × 240 (DK arcade aspect), scaled FIT +
// CENTER_BOTH, pixelArt: true, roundPixels: true.
//
// `pauseOnBlur: true` (PITFALL #13 / threat-model T-01-04) is wired here
// on the Phaser game config. In Phaser 3.90 this property is the
// SoundManager flag (default true); the broader RAF auto-pause is
// handled by Phaser's built-in VisibilityHandler regardless. The
// `MAX_DT_MS` cap in PlayerController (Wave 3) is the per-body
// belt-and-braces companion that catches any RAF backlog the
// VisibilityHandler misses on slow tab-resume. The literal property
// is not in the public `GameConfig` type for 3.90, so we cast — see
// SUMMARY deviations.
// World gravity is zero — per-body gravity only (RESEARCH Pattern 5)
// so asymmetric fall + fast-fall multipliers never leak into hazard
// physics.

import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { PreloadScene } from './scenes/PreloadScene';
import { MenuScene } from './scenes/MenuScene';
import { RunScene } from './scenes/RunScene';
import { RunUIScene } from './scenes/RunUIScene';
import { CashierScene } from './scenes/CashierScene';
import { RunOverScene } from './scenes/RunOverScene';

const NATIVE_WIDTH = 320;
const NATIVE_HEIGHT = 240;

new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'game-container',
  width: NATIVE_WIDTH,
  height: NATIVE_HEIGHT,
  backgroundColor: '#08050a',
  pixelArt: true,
  roundPixels: true,
  // pauseOnBlur: true — read at runtime by SoundManager; not in the
  // public GameConfig type. Cast below keeps strict-TS happy.
  pauseOnBlur: true,
  fps: { forceSetTimeOut: false },
  physics: {
    default: 'arcade',
    arcade: { gravity: { x: 0, y: 0 }, debug: false },
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  scene: [BootScene, PreloadScene, MenuScene, RunScene, RunUIScene, CashierScene, RunOverScene],
} as Phaser.Types.Core.GameConfig);
